import { render } from "./Won.vue?vue&type=template&id=28b1d00c"
import script from "./Won.vue?vue&type=script&lang=js"
export * from "./Won.vue?vue&type=script&lang=js"

import "./Won.vue?vue&type=style&index=0&id=28b1d00c&lang=scss"

import exportComponent from "/Users/nwitte/personal/development/git/zz_archive/odu-tech-talent/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__